export default "__VITE_ASSET__CuRgMav1__"